// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-option {
  text-transform: capitalize !important;
}

ion-icon {
  font-size: 50px;
  vertical-align: middle;
}

span {
  vertical-align: middle;
  margin-left: 10px;
  display: inline-block;
  height: 30px;
  line-height: 34px;
}

.cog-icon {
  font-size: 22px;
  line-height: 34px;
  vertical-align: middle;
  height: 30px;
  display: inline-block;
  position: absolute;
  right: 5px;
  color: var(--ion-color-medium-shade);
}

.icon-online {
  color: var(--ion-color-medium);
}

.icon-offline {
  color: #ffffff;
}

.thumbnail-online {
  background-color: rgba(var(--ion-color-medium-rgb), 0.08);
}

.thumbnail-offline {
  background-color: var(--ion-color-dark);
}

ion-thumbnail {
  font-size: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
}

ion-icon {
  font-size: 30px;
  transition: 0.2s linear;
}

/* Delete option: keeps its normal colour, turns red with a light red tint on hover */
ion-item-option.option-delete {
  transition: background-color 0.15s ease, color 0.15s ease;
}
ion-item-option.option-delete:hover {
  --ion-color-base: rgba(var(--ion-color-danger-rgb), 0.1) !important;
  --ion-color-contrast: var(--ion-color-danger) !important;
  background: rgba(var(--ion-color-danger-rgb), 0.1);
  color: var(--ion-color-danger);
}
ion-item-option.option-delete:hover ion-icon {
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/plant/plant.component.scss","webpack://./src/components/general%20components/plant/plant.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;ACCF;;ADEA;EACE,eAAA;EACA,sBAAA;ACCF;;ADEA;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;ACCF;;ADEA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,oCAAA;ACCF;;ADEA;EACE,8BAAA;ACCF;;ADEA;EACE,cAAA;ACCF;;ADGA;EACE,yDAAA;ACAF;;ADGA;EACE,uCAAA;ACAF;;ADGA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;ACAF;;ADGA;EACE,eAAA;EACA,uBAAA;ACAF;;ADGA,qFAAA;AACA;EACE,yDAAA;ACAF;ADEE;EACE,mEAAA;EACA,wDAAA;EACA,kDAAA;EACA,8BAAA;ACAJ;ADEI;EACE,8BAAA;ACAN","sourcesContent":["ion-item-option {\n  text-transform: capitalize !important;\n}\n\nion-icon {\n  font-size: 50px;\n  vertical-align: middle;\n}\n\nspan {\n  vertical-align: middle;\n  margin-left: 10px;\n  display: inline-block;\n  height: 30px;\n  line-height: 34px;\n}\n\n.cog-icon {\n  font-size: 22px;\n  line-height: 34px;\n  vertical-align: middle;\n  height: 30px;\n  display: inline-block;\n  position: absolute;\n  right: 5px;\n  color: var(--ion-color-medium-shade);\n}\n\n.icon-online{\n  color: var(--ion-color-medium);\n}\n\n.icon-offline{\n  color: #ffffff;\n}\n\n\n.thumbnail-online{\n  background-color: rgba(var(--ion-color-medium-rgb), 0.08);\n}\n\n.thumbnail-offline{\n  background-color: var(--ion-color-dark);\n}\n\nion-thumbnail {\n  font-size: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n}\n\nion-icon {\n  font-size: 30px;\n  transition: 0.2s linear;\n}\n\n/* Delete option: keeps its normal colour, turns red with a light red tint on hover */\nion-item-option.option-delete {\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    --ion-color-base: rgba(var(--ion-color-danger-rgb), 0.1) !important;\n    --ion-color-contrast: var(--ion-color-danger) !important;\n    background: rgba(var(--ion-color-danger-rgb), 0.1);\n    color: var(--ion-color-danger);\n\n    ion-icon {\n      color: var(--ion-color-danger);\n    }\n  }\n}\n","ion-item-option {\n  text-transform: capitalize !important;\n}\n\nion-icon {\n  font-size: 50px;\n  vertical-align: middle;\n}\n\nspan {\n  vertical-align: middle;\n  margin-left: 10px;\n  display: inline-block;\n  height: 30px;\n  line-height: 34px;\n}\n\n.cog-icon {\n  font-size: 22px;\n  line-height: 34px;\n  vertical-align: middle;\n  height: 30px;\n  display: inline-block;\n  position: absolute;\n  right: 5px;\n  color: var(--ion-color-medium-shade);\n}\n\n.icon-online {\n  color: var(--ion-color-medium);\n}\n\n.icon-offline {\n  color: #ffffff;\n}\n\n.thumbnail-online {\n  background-color: rgba(var(--ion-color-medium-rgb), 0.08);\n}\n\n.thumbnail-offline {\n  background-color: var(--ion-color-dark);\n}\n\nion-thumbnail {\n  font-size: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n}\n\nion-icon {\n  font-size: 30px;\n  transition: 0.2s linear;\n}\n\n/* Delete option: keeps its normal colour, turns red with a light red tint on hover */\nion-item-option.option-delete {\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\nion-item-option.option-delete:hover {\n  --ion-color-base: rgba(var(--ion-color-danger-rgb), 0.1) !important;\n  --ion-color-contrast: var(--ion-color-danger) !important;\n  background: rgba(var(--ion-color-danger-rgb), 0.1);\n  color: var(--ion-color-danger);\n}\nion-item-option.option-delete:hover ion-icon {\n  color: var(--ion-color-danger);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
